import Contaier from '../../../components/layout_micro/container'
import React from 'react'
import styled from 'styled-components'
import step1 from '../../../../assets/1.svg'
import step2 from '../../../../assets/2.svg'
import step3 from '../../../../assets/3.svg'
import step4 from '../../../../assets/4.svg'
import step5 from '../../../../assets/5.svg'
import { ButtonBase, Hidden } from '@material-ui/core'
import { useHistory } from 'react-router-dom'

const Wrapper = styled.div`
  background-color: var(--second);
  margin-top: 40px;
  @media screen and (max-width: 500px) {
    margin-top: 20px;
  }
`
const Title = styled.div`
  font-family: 'imlbold'; font-weight: bold;
  font-size: 3.2em;
  color: #fff;
  margin: 1em 0px;
  text-align: center;
`
const Int = styled.div`
  padding: 1px;
`
const CardList = styled.div`
  display: flex;
  justify-content: center;
  align-items: stretch;
  flex-wrap: wrap;
`
const CardWrapper = styled.div`
  box-sizing: border-box;
  padding: 15px;
  box-sizing: border-box;
  width: 20%;
  @media screen and (max-width:1600px) {
    padding: 10px;
  }
  @media screen and (max-width:800px) {
    width: 33.3%!important;
  }
  @media screen and (max-width:500px) {
    width: 50%!important;
    margin-top: 10px;
  }
`
const Card = styled.div`
  padding: 1px;
  background: #fff;
  border-radius: 15px;
  position: relative;
  height: 100%;
`
const CardNumber = styled.div`
  width: 45px;
  height: 45px;
  border-radius: 50%;
  margin: auto;
  background: var(--first);
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: -15px;
  right: 0px;
  left: 0px;
  margin: auto;
  color: #fff;
  font-size: 1.2em;
  border: 2px solid #fff;
  @media screen and (max-width:1600px) {
    width: 35px;
    height: 35px;
  }
`
const CardBody = styled.div`
  margin-top: 10px;
  justify-content: center;
  padding: 10px;
`
const CardImage = styled.img`
  width: 50%;
  margin: auto;
  display: block;
  height: 160px;
  object-fit: center;
  @media screen and (max-width:1600px) {
    height: 130px;
  }
  @media screen and (max-width:1100px) {
    height: 110px;
  }
`
const Divider = styled.div`
  border-bottom: 2px solid var(--first);
  width: 70%;
  margin: auto;
`
const CardText = styled.div`
  font-size: 1.1em;
  line-height: 1em;
  margin-top: 20px;
  text-align: center;
  font-family: 'imlbold'; font-weight: bold;
  color: var(--first);
  @media screen and (max-width:500px) {
    margin-top: 10px;
  }
`
const ButtonCOntainer = styled.div`
  margin: 4em auto;
`
const ButtonStyles = styled(ButtonBase)`
  color: #fff;
  background: var(--first);
  padding: .9em 1.5em;
  border-radius: 12px;
  font-size: 1.2em;
  font-family: 'imlmedium';
  display: block;
  margin: auto;
  text-transform: uppercase;
`

const Steps = props => {
  const history = useHistory()

  return (
    <Wrapper>
      <Contaier>
        <Int>
          <Title>Pasos para toma de muestra</Title>
          <CardList>
            <CardWrapper>
              <Card>
                <CardNumber>1</CardNumber>
                <CardBody>
                  <CardImage src={step1} />
                  <Divider />
                  <CardText>
                    Agenda tu cita
                  </CardText>
                </CardBody>
              </Card>
            </CardWrapper>
            <CardWrapper>
              <Card>
                <CardNumber>2</CardNumber>
                <CardBody>
                  <CardImage src={step2} />
                  <Divider />
                  <CardText>
                    Captura tus datos en el formulario
                  </CardText>
                </CardBody>
              </Card>
            </CardWrapper>
            <CardWrapper>
              <Card>
                <CardNumber>3</CardNumber>
                <CardBody>
                  <CardImage src={step3} />
                  <Divider />
                  <CardText>
                    Contesta el estudio Epidemiológico
                  </CardText>
                </CardBody>
              </Card>
            </CardWrapper>
            <CardWrapper>
              <Card>
                <CardNumber>4</CardNumber>
                <CardBody>
                  <CardImage src={step4} />
                  <Divider />
                  <CardText>
                    Realiza tu pago
                  </CardText>
                </CardBody>
              </Card>
            </CardWrapper>
            <CardWrapper>
              <Card>
                <CardNumber>5</CardNumber>
                <CardBody>
                  <CardImage src={step5} />
                  <Divider />
                  <CardText>
                    Envía tu IFE/INE y comprobante de pago por whatsapp o email
                  </CardText>
                </CardBody>
              </Card>
            </CardWrapper>
          </CardList>
          <ButtonCOntainer>
            <Hidden xsDown>
              <ButtonStyles onClick={event => history.push('/appointment')}>
                Agenda tu cita
              </ButtonStyles>
            </Hidden>
          </ButtonCOntainer>
        </Int>
      </Contaier>
    </Wrapper>
  )
}

export default Steps
